import apiClient from '../lib/apiClient'
import store from 'reducers'


export default class Actions {
    /**
     * @returns {apiClient}
     */
    static get client(){
        return apiClient
    }

    static get state(){
        return store.getState()
    }

    static get value() {
        return this.state[this.target]
    }

    static set(data){
        store.dispatch({
            type: 'set',
            target: this.target,
            payload: data
        })
    }

    static assign(data){
        store.dispatch({
            type: 'assign',
            target: this.target,
            payload: data
        })
    }

    static merge(data){
        this.assign(data)
    }

    static append(data){
        this.assign({
            [`${data.id}`]: {...data}
        })
    }

    static update(data){
       this.append(data) 
    }

    static appendMany(data){
        this.assign(data)
    }

    static remove(data){
        store.dispatch({
            type: 'remove',
            target: this.target,
            payload: data
        })
    }
}


// WEBPACK FOOTER //
// ./actions/Actions.js